import { render, staticRenderFns } from "./checkRate.vue?vue&type=template&id=3b1dd338&scoped=true&"
import script from "./checkRate.vue?vue&type=script&lang=js&"
export * from "./checkRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1dd338",
  null
  
)

export default component.exports